/**
 * Example auth api connector that lets your user log in using a defined payload
 * and returns a promise
 *
 */

import api from '@/config/api'
import vuex from '@/store'
import catchErrors from './catchErrors'

export default {
  getGroupsByStations(stations = []) {
    let params = { stations, include: 'roles' }
    return catchErrors.get(`/v2/newsdesk/workspace/groups`, {
      params,
      cache: {
        maxAge: 1000
      }
    })
  },
  getAllGroups(station) {
    station = station ?? vuex.getters.currentStation.station
    if (!station) return []
    let params = { include: 'roles' }
    return catchErrors.get(`/v2/newsdesk/groups/${station}`, { params })
  },
  createGroup(name, station) {
    station = station ?? vuex.getters.currentStation.station
    let formData = new FormData()
    formData.append('name', name)
    return catchErrors.post(`/v2/newsdesk/groups/${station}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      },
      raxConfig: {
        retry: 5
      }
    })
  },
  async editGroup(id, data) {
    let station = vuex.getters.currentStation.station
    let payload = {
      name: data.name,
      roles: data.roles
    }
    let resp = await catchErrors.patch(`/v2/newsdesk/groups/${station}/${id}`, payload)
    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  },
  async deleteGroup(id) {
    let station = vuex.getters.currentStation.station
    let resp = await catchErrors.delete(`/v2/newsdesk/groups/${station}/${id}`)
    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  },
  getGroup(id, station) {
    station = station ?? vuex.getters.currentStation?.station ?? ''
    return catchErrors.get(`/v2/newsdesk/groups/${station}/${id}`)
  },
  async addStationToGroups(station, groupIds) {
    station = station ?? vuex.getters.currentStation.station
    let formData = new FormData()
    groupIds.forEach((groupId) => {
      formData.append('group_id[]', groupId)
    })
    let resp = await catchErrors.post(`/v2/newsdesk/workspace/groups/${station}/attach`, formData, {
      raxConfig: {
        retry: 2
      }
    })

    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  },
  async removeStationFromGroups(station, groupIds) {
    station = station ?? vuex.getters.currentStation.station
    let formData = new FormData()
    groupIds.forEach((groupId) => {
      formData.append('group_id[]', groupId)
    })
    let resp = await catchErrors.post(`/v2/newsdesk/workspace/groups/${station}/detach`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      },
      raxConfig: {
        retry: 2
      }
    })

    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  }
}
